import { AppRoot } from '@telegram-apps/telegram-ui';
import { NavLink, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { HomePage } from '@/pages/HomePage';
import { UploadMediaPage } from '@/pages/UploadMediaPage';
import { SmartFormPage } from '@/pages/SmartFormPage';
import { SuccessPage } from '@/pages/SuccessPage';
import { HistoryPage } from '@/pages/HistoryPage';
import { AnalyticsPage } from '@/pages/AnalyticsPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { WalletPage } from '@/pages/WalletPage';
import { SubmissionDetailsPage } from '@/pages/SubmissionDetailsPage';

const TABS = [
  { to: '/',          icon: '🏠', label: 'Главная' },
  { to: '/analytics', icon: '📊', label: 'Аналитика' },
  { to: '/history',   icon: '📜', label: 'История' },
  { to: '/profile',   icon: '👤', label: 'Профиль' },
];

export function App() {
  return (
    <AppRoot appearance="dark" platform="base">
      <div className="app-shell">
        <main className="app-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/upload" element={<UploadMediaPage />} />
            <Route path="/upload/details" element={<SmartFormPage />} />
            <Route path="/success/:id" element={<SuccessPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/wallet" element={<WalletPage />} />
            <Route path="/submissions/:id" element={<SubmissionDetailsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <TabBar />
      </div>
    </AppRoot>
  );
}

function TabBar() {
  const location = useLocation();
  // Hide tab bar on full-screen flows (upload, success, submission details).
  const hide = ['/upload', '/success', '/submissions'].some((p) => location.pathname.startsWith(p));
  if (hide) return null;
  return (
    <nav className="tabs" aria-label="Основная навигация">
      {TABS.map((t) => (
        <NavLink key={t.to} to={t.to} end={t.to === '/'}>
          <span className="tab-icon" aria-hidden>{t.icon}</span>
          <span>{t.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
